import firebase from 'firebase/compat/app';
import 'firebase/firestore';
import { environment } from '../environments/environment';

firebase.initializeApp(environment.firebase);
